import * as React from "react"
import { ActionAnchor } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import env from "../../../env"
import { IItemNavigation } from "../index"

interface Props {
    prev?: IItemNavigation
    next?: IItemNavigation
}

export default function LateralNavigation({ prev, next }: Props): JSX.Element {
    return (
        <div id="newui-lateralnavigation-buttons" className="tw-flex tw-px-2">
            {!!prev && (
                <ActionAnchor
                    id="newui-lateralnavigation-prev"
                    extraClasses="theme-thumb"
                    href={env.applicationPath + prev.url}
                >
                    <div className="p text-action tw-mr-2">
                        {Symbols.ArrowLeft}
                    </div>
                    <h3 className="text-action tw-mr-2">{prev.icon}</h3>
                    <div>
                        <div className="label text-black is-dimmed">
                            {prev.label}
                        </div>
                        <div className="p text-action">{prev.title}</div>
                    </div>
                </ActionAnchor>
            )}
            <div className="tw-flex-grow"></div>
            {!!next && (
                <ActionAnchor
                    id="newui-lateralnavigation-next"
                    extraClasses="theme-thumb"
                    href={env.applicationPath + next.url}
                >
                    <h3 className="text-action tw-mr-2">{next.icon}</h3>
                    <div>
                        <div className="label text-black is-dimmed">
                            {next.label}
                        </div>
                        <div className="p text-action">{next.title}</div>
                    </div>
                    <div className="p text-action tw-ml-2">
                        {Symbols.ArrowRight}
                    </div>
                </ActionAnchor>
            )}
        </div>
    )
}
